import React, { useEffect, useState, useCallback } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import secureLocalStorage from "react-secure-storage";
import { ToastContainer, toast } from "react-toastify";

const API_BASE = process.env.REACT_APP_API;

const styles = {
  page: {
  minHeight: "100vh",
  backgroundColor: "#f7f7f7",
  fontFamily: "'Segoe UI', sans-serif",
  margin: "0 auto",
  position: "relative",
  paddingBottom: 100, // 👈 100 se 140 kar do
},

  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "16px 16px",
    backgroundColor: "#fff",
    borderBottom: "1px solid #eee",
    position: "sticky",
    top: 0,
    zIndex: 10,
  },
  backBtn: {
    position: "absolute",
    left: 16,
    background: "none",
    border: "none",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    padding: 4,
  },
  headerTitle: {
    fontSize: 18,
    fontWeight: 700,
    color: "#111",
    margin: 0,

  },
  body: {
    padding: "16px",
  },
  sectionLabel: {
    fontSize: 16,
    fontWeight: 700,
    color: "#111",
    marginBottom: 2,
    textAlign: "justify",
  },
  sectionCount: {
    fontSize: 13,
    color: "#999",
    marginBottom: 12,
      textAlign: "justify",
  },
  itemCard: {
    backgroundColor: "#fff",
    borderRadius: 14,
    padding: "14px 14px",
    marginBottom: 12,
    display: "flex",
    alignItems: "center",
    gap: 12,
    boxShadow: "0 1px 6px rgba(0,0,0,0.06)",
  },
  itemImg: {
    width: 58,
    height: 58,
    borderRadius: 10,
    objectFit: "cover",
    cursor: "pointer",
    flexShrink: 0,
  },
  itemInfo: {
    flex: 1,
  },
  itemTitle: {
    fontSize: 14,
    fontWeight: 600,
    color: "#222",
    margin: "0 0 5px 0",
      textAlign: "justify",
  },
  badge: {
    display: "inline-block",
    backgroundColor: "#e8f5e9",
    color: "#2e7d32",
    fontSize: 11,
    fontWeight: 600,
    borderRadius: 6,
    padding: "2px 8px",
  },
  deleteBtn: {
    background: "none",
    border: "none",
    cursor: "pointer",
    padding: 6,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  divider: {
    height: 1,
    backgroundColor: "#eee",
    margin: "16px 0",
  },
  addressBlock: {
    backgroundColor: "#f0f4ff",
    borderRadius: 12,
    padding: "14px 14px",
    marginBottom: 4,
    position: "relative",
  },
  addressCity: {
    fontSize: 15,
    fontWeight: 700,
    color: "#1a3a8f",
    margin: "0 0 4px 0",
    textAlign: "justify",
  },
  addressLine: {
    fontSize: 13,
    color: "#555",
    margin: "0 0 2px 0",
    textAlign: "justify",
  },
  changeBtn: {
    float: "right",
    background: "none",
    border: "none",
    color: "#1a3a8f",
    fontSize: 14,
    fontWeight: 700,
    cursor: "pointer",
    padding: "10px",

  },
  totalRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "18px 4px 0",
    width: "100%",
  },
  totalLabel: {
    fontSize: 16,
    fontWeight: 700,
    color: "#111",
  },
  totalValue: {
    fontSize: 16,
    fontWeight: 700,
    color: "#1a3a8f",
  },
 placeOrderBtn: {
  width: "100%",
  padding: "15px 16px", // 👈 thoda increase
  borderTop: "1px solid #eee",
  zIndex: 20,
},

 placeOrderInner: {
  backgroundColor: "#1a3a8f",
  color: "#fff",
  border: "none",
  borderRadius: 5,
  width: "100%",
  padding: "10px", // 👈 15 se 18 karo
  fontSize: 16,
  fontWeight: 700,
  cursor: "pointer",
},

  emptyBox: {
    textAlign: "center",
    paddingTop: 80,
  },
  spinner: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "60vh",
  },
  spinnerCircle: {
    width: 36,
    height: 36,
    border: "3px solid #ddd",
    borderTop: "3px solid #1a3a8f",
    borderRadius: "50%",
    animation: "spin 0.7s linear infinite",
  },
};

const BackSVG = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="#333">
    <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" />
  </svg>
);

const TrashSVG = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="#e53935">
    <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" />
  </svg>
);

const CardList = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const selectAddress = location.state?.selectAddress;
  console.log("selectAddress:", selectAddress);
  const _id = secureLocalStorage.getItem("n_id");
  const token = secureLocalStorage.getItem("n_token");
  const offerprice = secureLocalStorage.getItem("n_offerprice");
  const [show_cart_list, setshow_cart_list] = useState([]);
  const [totolprice, settotalprice] = useState(0);
  const [showdelivery, setshowdelivery] = useState(0);
  const [offer_price] = useState(0);
  const [productQuantities, setProductQuantities] = useState({});
  const [loading, setLoading] = useState(true);
  const [deletingItems, setDeletingItems] = useState(new Set());
  const [cartId, setCartId] = useState(null);
  const [selectedAddress, setSelectedAddress] = useState(selectAddress || null);
  const [placingOrder, setPlacingOrder] = useState(false);
  const axiosInstance = axios.create({ baseURL: API_BASE, timeout: 20000 });
  axiosInstance.interceptors.request.use((cfg) => {
    if (token) cfg.headers = { ...(cfg.headers || {}), token };
    return cfg;
  });
  const alltotal =
    parseFloat(totolprice) + showdelivery - (offer_price || 0);
  useEffect(() => {
    const newTotal = show_cart_list.reduce((acc, item) => {
      const q = productQuantities[item.product_id] ?? item.no_of_product ?? 1;
      const price = Number(String(item.price).replace(/,/g, ""));
      return acc + price * q;
    }, 0);
    settotalprice(newTotal.toFixed(2));
  }, [show_cart_list, productQuantities]);

  const fetchCartDetails = useCallback(async () => {
    try {
      setLoading(true);
      const res = await axiosInstance.post("website/cart_details", {
        user_id: _id,
      });
      
      const data = res?.data?.data ?? [];
      setCartId(res?.data?.cart_id || null);
      setshow_cart_list(Array.isArray(data) ? data : []);
      const initialQ = {};
      (Array.isArray(data) ? data : []).forEach((it) => {
        initialQ[it.product_id] = it.no_of_product ?? 1;
      });
      setProductQuantities(initialQ);
    } catch {
      toast.error("Failed to load cart items");
    } finally {
      setLoading(false);
    }
  }, [_id, token]);

  const fetchAddress = useCallback(async () => {
    try {
      const res = await axios.post(`${API_BASE}website/get_address`, {
        user_id: _id,
      });
      if (res.data.result && res.data.data?.length > 0) {
        if (selectAddress) {
          setSelectedAddress(selectAddress);
        } else {
          setSelectedAddress(res.data.data[0]);
        }
      }
    } catch {
      // silent
    }
  }, [_id]);

  useEffect(() => {
    fetchCartDetails();
    fetchAddress();
  }, [fetchCartDetails, fetchAddress]);

  useEffect(() => {
    const fetchDeliveryCharge = async () => {
      if (!token) return;
      try {
        const res = await axiosInstance.get("/website/delivery_charge_list");
        const charge = res?.data?.data?.delivery_charge;
        if (typeof charge === "number") setshowdelivery(charge);
      } catch {
        // silent
      }
    };
    fetchDeliveryCharge();
  }, [token]);

  const delete_card = async (productId) => {
    if (deletingItems.has(productId)) return;
    setDeletingItems((prev) => new Set(prev).add(productId));
    try {
      const res = await axiosInstance.post("website/delete_cart_product", {
        user_id: _id,
        product_id: productId,
        quantity: "0",
        cart_id: cartId,
      });
      if (res?.data?.result || res?.data?.success) {
        setshow_cart_list((prev) => {
          const updated = prev.filter((it) => it.product_id !== productId);
          if (updated.length === 0) setTimeout(() => navigate("/"), 700);
          return updated;
        });
        setProductQuantities((prev) => {
          const copy = { ...prev };
          delete copy[productId];
          return copy;
        });
        toast.success("Item removed");
        setTimeout(fetchCartDetails, 600);
      } else {
        toast.error(res?.data?.message || "Failed to remove item");
        fetchCartDetails();
      }
    } catch {
      toast.error("Failed to remove item");
      fetchCartDetails();
    } finally {
      setDeletingItems((prev) => {
        const s = new Set(prev);
        s.delete(productId);
        return s;
      });
    }
  };

  const handlePlaceOrder = async () => {
    if (!selectedAddress) {
      toast.error("Please add a delivery address");
      navigate("/address");
      return;
    }
    setPlacingOrder(true);
    try {
      const data = {
        user_id: _id,
        cart_id: cartId,
        address_id: selectedAddress._id,
        available_status: show_cart_list?.some(
          (item) => item.available_status === "Buy"
        )
          ? "Buy"
          : "Lease",
        address: selectedAddress.address,
        city: selectedAddress.city,
        pin_code: selectedAddress.pin_code,
        discount_price: offerprice || "0",
        grand_total: Math.floor(alltotal),
      };
      const res = await axios.post(`${API_BASE}website/booking_order`, data);
      if (res.data.result) {
        toast.success("Order placed successfully!");
        setTimeout(() => navigate("/orders"), 1000);
      } else {
        toast.error(res.data.message || "Failed to place order");
      }
    } catch {
      toast.error("Failed to place order");
    } finally {
      setPlacingOrder(false);
    }
  };

  if (loading) {
    return (
      <div style={styles.spinner}>
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
        <div style={styles.spinnerCircle} />
      </div>
    );
  }

  return (
    <>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      <ToastContainer position="top-center" />
      <div style={styles.page}>
        {/* Header */}
        <div style={styles.header}>
          <button style={styles.backBtn} onClick={() => navigate(-1)}>
            <BackSVG />
          </button>
          <h1 style={styles.headerTitle}>Place order</h1>
        </div>

        <div style={styles.body}>
          {show_cart_list.length === 0 ? (
            <div style={styles.emptyBox}>
              <p style={{ color: "#999", fontSize: 16 }}>Your cart is empty</p>
              <Link
                to="/"
                style={{
                  color: "#1a3a8f",
                  fontWeight: 600,
                  textDecoration: "none",
                }}
              >
                Continue Shopping
              </Link>
            </div>
          ) : (
            <>
              {/* Selected Items */}
              <p style={styles.sectionLabel}>Selected Items</p>
              <p style={styles.sectionCount}>
                {show_cart_list.length} Item{show_cart_list.length > 1 ? "s" : ""}
              </p>

              {show_cart_list.map((item, index) => {
                const isDeleting = deletingItems.has(item.product_id);
                return (
                  <div
                    key={`${item.product_id}-${index}`}
                    style={styles.itemCard}
                  >
                    <img
                      src={`${API_BASE}uploads/${item.product_image}`}
                      alt={item.product_title}
                      style={styles.itemImg}
                      onClick={() => {
                        
                        navigate(`/single_products/${item.product_id}`);
                      }}
                    />
                    <div style={styles.itemInfo}>
                      <p style={styles.itemTitle}>{item.product_title}</p>
                      <span style={styles.badge}>
                        {item.available_status || "BUY"}
                      </span>
                    </div>
                    <button
                      style={styles.deleteBtn}
                      onClick={() => !isDeleting && delete_card(item.product_id)}
                      disabled={isDeleting}
                    >
                      {isDeleting ? (
                        <div
                          style={{
                            ...styles.spinnerCircle,
                            width: 18,
                            height: 18,
                            borderWidth: 2,
                          }}
                        />
                      ) : (
                        <TrashSVG />
                      )}
                    </button>
                  </div>
                );
              })}

              <div style={styles.divider} />

              {/* Delivery Address */}
              <p style={{ ...styles.sectionLabel, marginBottom: 10 }}>
                Delivery Address
              </p>

              {selectedAddress ? (
                <div style={styles.addressBlock}>
                  <p style={styles.addressCity}>{selectedAddress.city}</p>
                  <p style={styles.addressLine}>
                    {selectedAddress.city} Pincode: {selectedAddress.pin_code}
                  </p>
                  <p style={styles.addressLine}>{selectedAddress.address}</p>
                  <button
                    style={styles.changeBtn}
                    onClick={() => navigate("/address", { state: { fromCart: true } })}
                  >
                    Change
                  </button>
                </div>
              ) : (
                <div
                  style={{
                    ...styles.addressBlock,
                    cursor: "pointer",
                    textAlign: "center",
                  }}
                  onClick={() => navigate("/address")}
                >
                  <p
                    style={{
                      color: "#1a3a8f",
                      fontWeight: 600,
                      margin: 0,
                      fontSize: 14,
                    }}
                  >
                    + Add Delivery Address
                  </p>
                </div>
              )}

              {/* Total */}
              <div style={styles.totalRow}>
                <span style={styles.totalLabel}>Total Amount</span>
                <span style={styles.totalValue}>
                  ₹{Number(alltotal).toLocaleString("en-IN")}
                </span>
              </div>
            </>
          )}
        </div>

        {/* Place Order Button */}
        {show_cart_list.length > 0 && (
          <div style={styles.placeOrderBtn}>
            <button
              style={{
                ...styles.placeOrderInner,
                opacity: placingOrder ? 0.7 : 1,
              }}
              onClick={handlePlaceOrder}
              disabled={placingOrder}
            >
              {placingOrder ? "Placing Order..." : "Place Order"}
            </button>
          </div>
        )}
      </div>
    </>
  );
};

export default CardList;